export default "__VITE_ASSET__b8819e36__"